module.exports = __webpack_public_path__ + "static/media/club-list.4d25e845.png";